import React from "react"
import { translate } from "react-i18next"
import PropTypes from "prop-types"
import Widget from "../layout/widget/Widget"
import ColumnChart from "../charts/generic/ColumnChart"
import ItemNameCountShape from "../../state/shapes/ItemNameCountShape"
import { formatDecimalForDisplay } from "../../utils/formatting-utils"

function ValueAlignment({ exportEndpoint, data, appliedFilters, t, subtitleKey, sampleSize }) {
  const barChartData = {
    categories: [],
    bars: []
  }

  const singleDataItem = {
    data: [],
    showInLegend: false
  }

  data.forEach(d => {
    barChartData.categories.push(d.itemName)
    singleDataItem.data.push({ y: d.percentage, count: d.count })
  })
  barChartData.bars.push(singleDataItem)

  const formatTooltip = context => {
    if (context.point.count === 1) {
      return `<b>${context.x}:</b> 
      ${formatDecimalForDisplay(context.y)}% (${context.point.count} ${t("Common.Person")})`
    }
    
    return `<b>${context.x}:</b> 
    ${formatDecimalForDisplay(context.y)}% (${context.point.count} ${t("Common.People")})`
  }

  const titleKey="Widgets.ValueAlignment.Title"
  return (
    <Widget
      columns={2}
      titleKey={titleKey}
      exportEndpoint={exportEndpoint}
      appliedFilters={appliedFilters}
      subtitleKey={subtitleKey}
      sampleSize={sampleSize}
    >
      <ColumnChart
        data={barChartData}
        yAxisTitle="Common.Percentage"
        xAxisTitle="Widgets.ValueAlignment.Scale"
        chartType="column"
        tooltipFormatter={formatTooltip}
        titleKey={titleKey}
        subtitleKey={subtitleKey}
      />
    </Widget>
  )
}

ValueAlignment.propTypes = {
  appliedFilters: PropTypes.arrayOf(PropTypes.string).isRequired,
  data: PropTypes.arrayOf(PropTypes.shape(ItemNameCountShape)).isRequired,
  exportEndpoint: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired,
  subtitleKey: PropTypes.string,
  sampleSize: PropTypes.object
}

export default translate()(ValueAlignment)



// WEBPACK FOOTER //
// ./src/components/widgets/ValueAlignment.jsx